module.exports = __webpack_public_path__ + "img/16exp.ea00768b.jpg";